import { SET_BASEMAP } from './types';

export const setBasemap = basemap => ({
  type: SET_BASEMAP,
  basemap,
});

export default setBasemap;
